import { Box, Typography, CardMedia, Card, CardContent } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import CustomizeHotTopicButton from './NewsfeedCard/CustomizeHotTopicButton';

const useStyles = makeStyles()(theme => ({
  newsfeedCard: {
    margin: '1rem 0'
  },
  newsfeedColumn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem'
  },
  newsfeedCardContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.8rem',
    padding: '1rem',
    flex: 1,
    minWidth: 0
  },
  newsItemContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    padding: '0.6rem',
    cursor: 'pointer',
    borderRadius: '8px',
    '@media (hover: hover)': {
      '&:hover': {
        backgroundColor: '#f8f9fa'
      }
    },
    [theme.breakpoints.down(600)]: {
      alignItems: 'flex-start'
    }
  },
  newsItemBody: {
    display: 'contents',
    [theme.breakpoints.down(600)]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      flex: 1,
      minWidth: 0,
      gap: '0.4rem'
    }
  },
  newsfeedImage: {
    width: '72px',
    height: '40.5px',
    borderRadius: '0.5rem',
    backgroundColor: '#f0f3f4',
    flexShrink: 0
  },
  newsfeedCardTrailling: {
    display: 'flex',
    margin: 'auto',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f0f3f4',
    padding: '0.85',
    borderRadius: '0.2rem'
  },
  newsItemActions: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    gap: '1.2rem'
  },
  newsItemArrow: {
    color: '#617c89',
    fontSize: '1.51rem',
    flexShrink: 0,
    cursor: 'pointer',
    [theme.breakpoints.down(600)]: {
      alignSelf: 'center',
      marginLeft: 'auto'
    }
  },
  newsfeedCardTitle: {
    color: '#111618',
    fontSize: '1.75rem',
    fontWeight: 400,
    lineHeight: 1.4,
    flex: 1,
    minWidth: 0,
    [theme.breakpoints.down(600)]: {
      flex: 'none',
      width: '100%'
    }
  },
  newsfeedCardSubtitle: {
    color: '#617c99',
    fontSize: '1.17rem',
    fontWeight: 400,
    lineHeight: 'normal',
    [theme.breakpoints.down(600)]: {
      paddingLeft: '0.6rem'
    }
  }
}));

export default function SelectedNewsfeedCard({ intl, selectedNewsfeed, index, title, history, onOpenNewsItem }) {
  const { classes } = useStyles();

  const formatCreatedAt = createdAt => {
    const locale = intl.locale;
    return new Date(createdAt).toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' });
  };
  return (
    <Card key={index} className={classes.newsfeedCard}>
      {title && (
        <CardContent>
          <Typography variant="h6">{title}</Typography>
        </CardContent>
      )}
      <Box className={classes.newsfeedColumn}>
        <Box className={classes.newsfeedCardContentContainer}>
          {selectedNewsfeed.attributes.news.map((newsItem, newsIndex) => {
            const image_url =
              newsItem.images?.image_url_thumbnail || newsItem.images?.image_url_pfp || newsItem.images?.image_url_poe;
            return (
              <Box
                key={newsItem.id || newsItem.news_id || newsIndex}
                className={classes.newsItemContainer}
                onClick={() => onOpenNewsItem && onOpenNewsItem(newsItem, newsIndex)}
              >
                <CardMedia className={classes.newsfeedImage} image={image_url} alt={newsItem.title} />
                <Box className={classes.newsItemBody}>
                  <Typography className={classes.newsfeedCardTitle}>{newsItem.title}</Typography>
                  <Box
                    className={classes.newsItemActions}
                    onClick={event => {
                      event.stopPropagation();
                    }}
                  >
                    <CustomizeHotTopicButton
                      news={newsItem}
                      intl={intl}
                      history={history}
                      newsfeedId={selectedNewsfeed.id}
                      appearance="list"
                    />
                  </Box>
                </Box>
                <ArrowForwardIosIcon className={classes.newsItemArrow} />
              </Box>
            );
          })}
          <Box>
            <Typography className={classes.newsfeedCardSubtitle}>
              {intl.formatMessage({ id: 'selected-newsfeed-update-at' })}{' '}
              {formatCreatedAt(selectedNewsfeed.attributes.createdAt)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Card>
  );
}
